import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from 'recharts'

type Datum = { name: string; value: number } // value is 0–100

export default function ModalityRadar({
  data,
  title = 'Your learning modality map',
  hideTitle = false,
  outerRadius = '63%',
  cx = '45%',
  cy = '46%',
}: {
  data: Datum[]
  title?: string
  hideTitle?: boolean
  outerRadius?: string
  cx?: string
  cy?: string
}) {
  if (!data?.length) return null

  const css = getComputedStyle(document.documentElement)
  //const primary = (css.getPropertyValue('--primary') || '#E52592').trim()
  const grid = (css.getPropertyValue('--color-grey-300') || '#E7E7E7').trim()
  //const label = (css.getPropertyValue('--color-grey-600') || '#4A4A4A').trim()

  // custom tick: top/bottom labels inline, left/right labels stacked
  const Tick = (props: any) => {
    const { payload, x, y, textAnchor, index } = props
    const datum = data[payload.index ?? index]
    const isTopOrBottom = textAnchor === 'middle'
    const isLeft = textAnchor === 'end'

    if (isTopOrBottom) {
      const isTop = y < 150
      const offsetY = isTop ? y - 10 : y + 10
      return (
        <text x={x} y={offsetY} textAnchor='middle' dominantBaseline='middle' fill='#1A1A1A' style={{ fontFamily: 'inherit' }}>
          <tspan fontSize={16} fontWeight={700}>
            {Math.round(datum?.value ?? 0)}%{' '}
          </tspan>
          <tspan fontSize={14} fontWeight={400}>
            {payload.value}
          </tspan>
        </text>
      )
    }

    // Left (Mastery): text ends before chart; Right (Cooperative): text starts after chart
    const anchor = isLeft ? 'end' : 'start'

    return (
      <text x={x} y={y} textAnchor={anchor} fill='#1A1A1A' style={{ fontFamily: 'inherit' }}>
        <tspan x={x} dy='-0.6em' fontSize={16} fontWeight={700}>
          {Math.round(datum?.value ?? 0)}%
        </tspan>
        <tspan x={x} dy='1.3em' fontSize={14} fontWeight={400}>
          {payload.value}
        </tspan>
      </text>
    )
  }

  return (
    <div className='w-full h-[373px]'>
      {!hideTitle && <div className='text-left text-base font-semibold text-[var(--color-grey-700)] [font-family:var(--font-effra)] mb-2'>{title}</div>}
      <ResponsiveContainer width='100%' height='100%'>
        <RadarChart data={data} outerRadius={outerRadius} cx={cx} cy={cy}>
          <PolarGrid gridType='polygon' stroke={grid} />
          <PolarAngleAxis dataKey='name' tick={<Tick />} tickLine={false} />
          <PolarRadiusAxis domain={[0, 100]} angle={90} tick={false} axisLine={false} />
          <Radar dataKey='value' stroke='#E52592' strokeWidth={2} fill='#E52592' fillOpacity={0.15} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  )
}
